import { DqiCategory } from "src/global/schemas/expectations/expectation-metadata-data-quality-issues"
import { DqiCategoryIcon } from "src/pages/DataAssets/components/DqiCategoryIcon"
import { theme } from "src/global/ui/themes/theme"

type DqiCoverageIconProps = {
  dqiCategory: DqiCategory
  size: "32px" | "24px" | "22px" | "20px" | "16px" | "12px" | "10px" | "8px" | "6px" | "4px" | "2px"
  covered: boolean
}

export const DqiCoverageIcon = (props: DqiCoverageIconProps) => {
  const { dqiCategory, size, covered } = props
  const iconColor = covered
    ? theme.colors.success.gxSuccess
    : theme.colors.neutralColorPalette.blacks.colorTextQuaternary
  const coverageText = covered ? "Covered" : "Not Covered"
  const ariaLabel = `${dqiCategory} ${coverageText}`
  return <DqiCategoryIcon dqiCategory={dqiCategory} color={iconColor} size={size} ariaLabel={ariaLabel} />
}
